export default "__VITE_ASSET__BRMmLTz3__"